export const tagsApi = (client) => ({
    list: () => client.get('/api/v1/tags').then((r) => r.data),
    get: (id) => client.get(`/api/v1/tags/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/tags', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/tags/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/tags/${id}`).then(() => undefined),
});
//# sourceMappingURL=tags.js.map